export const useUseCasesStore = defineStore('use-cases', () => {
  const listsStore = useListsStore()
  const teamsStore = useTeamsStore()

  const navigation = ref<LayoutHeaderNavigationGroups>([])
  const selectedListId = ref<number>()
  const selectedApiTokenId = ref<number>()
  const selectedWebhookId = ref<number>()

  const listOptions = computed(() => {
    return listsStore.lists.map((list): USelectMenuOption => {
      return {
        label: list.name,
        value: list.id,
      }
    })
  })

  const apiTokenOptions = computed(() => {
    return teamsStore.apiTokens.map((apiToken): USelectMenuOption => {
      return {
        label: apiToken.name,
        value: apiToken.id,
      }
    })
  })

  const markdownVariables = computed(() => {
    return {
      list: selectedList.value?.id,
      token: selectedApiToken.value?.token,
      webhook: selectedWebhook.value?.id,
    }
  })

  const selectedApiToken = computed(() => {
    return teamsStore.apiTokens.find(apiToken => apiToken.id === selectedApiTokenId.value)
  })

  const selectedList = computed(() => {
    return listsStore.lists.find(list => list.id === selectedListId.value)
  })

  const selectedWebhook = computed(() => {
    return teamsStore.webhooks.find(webhook => webhook.id === selectedWebhookId.value)
  })

  const webhookOptions = computed(() => {
    return teamsStore.webhooks.map((webhook): USelectMenuOption => {
      return {
        label: webhook.name,
        value: webhook.id,
      }
    })
  })

  watch(apiTokenOptions, (newOptions, oldOptions) => {
    if (oldOptions.length === 0 && newOptions.length > 0) {
      selectedApiTokenId.value = newOptions[0].value
    }
  })

  watch(listOptions, (newOptions, oldOptions) => {
    if (oldOptions.length === 0 && newOptions.length > 0) {
      selectedListId.value = newOptions[0].value
    }
  })

  watch(webhookOptions, (newOptions, oldOptions) => {
    if (oldOptions.length === 0 && newOptions.length > 0) {
      selectedWebhookId.value = newOptions[0].value
    }
  })

  const resetStore = () => {
    selectedListId.value = listOptions.value?.[0]?.value
    selectedApiTokenId.value = apiTokenOptions.value?.[0]?.value
    selectedWebhookId.value = webhookOptions.value?.[0]?.value
  }

  return {
    apiTokenOptions,
    listOptions,
    markdownVariables,
    navigation,
    resetStore,
    selectedApiToken,
    selectedApiTokenId,
    selectedList,
    selectedListId,
    selectedWebhook,
    selectedWebhookId,
    webhookOptions,
  }
})
